import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { clearSahakari, getSahakari } from '../../redux/actions/sahakari';
import ColorComponent from '../../components/ColorComponent';
import { tableTheme } from '../../helpers/tableTheme';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';

const columns = [
  {
    name: 'Id',
    label: 'Id',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'Username',
    label: 'Username',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'Sahakari Name',
    label: 'Sahakari Name',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'Phone Number',
    label: 'Phone Number',
    options: {
      filter: false,
      sort: false,
    },
  },
  // "Email",

  {
    name: 'Location',
    label: 'Location',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'Subscription until',
    label: 'Subscription until',
    options: {
      filter: false,
      sort: true,
    },
  },

  {
    name: 'Status',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return <ColorComponent value={value} />;
      },
    },
  },
  {
    name: 'Branch',
    label: 'Branch',
    options: {
      filter: false,
      sort: false,
    },
  },
];

function ViewSahakari({ history }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const sahakariData = useSelector((state) => state.sahakari.sahakariData);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getSahakari()).then(() => setIsLoading(false));
    return () => {
      dispatch(clearSahakari());
    };
  }, []);

  const onRowsSelect = (rowData, rowMeta) => {
    history.push(`/sahakari/profile/${rowData[0]}`);
  };
  const options = {
    filterType: 'checkbox',
    selectableRowsOnClick: false,
    onRowClick: onRowsSelect,
    responsive: 'standard',
    download: false,
    print: false,
    elevation:0,

    // selectToolbarPlacement: "above",
    // customToolbarSelect: () => <h6>h5</h6>,
  };

  //   const onRowsSelect = (rowData, rowMeta) => {
  //       console.log(rowData)
  //     // orders.map((order) => {
  //     //   if (order[1] === rowData[1]) {
  //     //     setRowData(order);
  //     //   }
  //     //   return null;
  //     // });
  //     // // setRowData(rowData);
  //     // setIsModalOpen(true);
  //   };
  return (
    <div>
      <MuiThemeProvider theme={tableTheme}>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <MUIDataTable
            title={'View Sahakari'}
            data={sahakariData}
            columns={columns}
            options={options}
          />
        )}
      </MuiThemeProvider>
    </div>
  );
}

export default ViewSahakari;
